import React from 'react';
import {cl} from './utils'
import FUISelect from '../../fui/controls/FUISelect';

var makeOptions=(opts)=>{
    return Object.keys(opts).map((k,i)=>{
      return (
        <option key={i} value={k}>{opts[k].t}</option>
      )
    })
  }

  var makeOptionsForFUISelect=(opts, keyOrder)=>{
    let hp=[]
    let keys = keyOrder || Object.keys(opts)
    keys.forEach((k)=>{
     if (!opts[k]) { return }
     let obj={}
     obj['v'] = +k
     obj['t']=opts[k].t
     hp.push(obj)
    })
    return {options:hp}
   }
  
var showSelect=(type, val,valId,ind,opts, onChange, keyOrder)=>{
//   cl(opts)
    let keys = keyOrder || Object.keys(opts)
    return(
      <select style={{marginLeft: "0.3em",}}
        value={val} 
        onChange={e=>onChange(type, valId,ind,e)}
      >
      {keys.map((k,i)=>{
        if (!opts[k]) { return null }
        return (
          <option key={i} value={+k}>{opts[k].t}</option>
        )
      })}
      </select>
    )
  }

  var showFUISelect=(type, val,valId,ind,opts, onChange, getValue, keyOrder, extraCustom, extraProps)=>{
    extraProps=extraProps||{}
        return(
          <FUISelect
          style={{marginLeft: "0.3em",}}
          getValue={getValue}
          custom={{...makeOptionsForFUISelect(opts, keyOrder), ...extraCustom}}
          value={val}
          saveOK={true}
          current={extraProps.current}
          zoneInfo={extraProps.zoneInfo}
          zuci={extraProps.zuci}
          onChange={(ind,vals)=>onChange(type, valId,ind,vals.e)}
          cont={{}} />
        )
      }

var showInput=(type, val, valId, ind, onChange, width=70, decimals)=>{
    let mult = Math.pow(10, decimals==null ? 4 : decimals)
    let stepProps = decimals==null ? {} : {step: 1/mult}
    return(
      <input
        style={{width:width}}
        value={Math.round(val*mult)/mult}
        type="number"
        inputMode="decimal"
        {...stepProps}
        onChange={e=>onChange(type, valId, ind, e)}
      />
    )
  }

  export {showSelect, showInput, showFUISelect
}
